import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { formatEncodingExceptionqalxwmlsg11w as formatEncodingException } from './internal/JsonExceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonDecodingExceptionClass;
function JsonDecodingException() {
  if (JsonDecodingExceptionClass === VOID) {
    class $ extends JsonException() {
      constructor(fullMessage, shortMessage, offset, path, input, hint, cause) {
        return new.target.z2r(fullMessage, shortMessage, offset, path, input, hint, cause);
      }
      static z2r(fullMessage, shortMessage, offset, path, input, hint, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.j2s(fullMessage, cause);
        captureStack($this, $this.y2r_1);
        $this.t2r_1 = shortMessage;
        $this.u2r_1 = offset;
        $this.v2r_1 = path;
        $this.w2r_1 = input;
        $this.x2r_1 = hint;
        return $this;
      }
    }
    initMetadataForClass($, 'JsonDecodingException');
    JsonDecodingExceptionClass = $;
  }
  return JsonDecodingExceptionClass;
}
var JsonExceptionClass;
function JsonException() {
  if (JsonExceptionClass === VOID) {
    class $ extends SerializationException() {
      static j2s(message, cause) {
        var $this = this.z1o(message, cause);
        captureStack($this, $this.i2s_1);
        $this.h2s_1 = message;
        delete $this.message;
        return $this;
      }
      r() {
        return this.h2s_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'JsonException');
    JsonExceptionClass = $;
  }
  return JsonExceptionClass;
}
var JsonEncodingExceptionClass;
function JsonEncodingException() {
  if (JsonEncodingExceptionClass === VOID) {
    class $ extends JsonException() {
      constructor(shortMessage, classSerialName, hint, cause) {
        return new.target.u2s(shortMessage, classSerialName, hint, cause);
      }
      static u2s(shortMessage, classSerialName, hint, cause) {
        classSerialName = classSerialName === VOID ? null : classSerialName;
        hint = hint === VOID ? null : hint;
        cause = cause === VOID ? null : cause;
        var $this = this.j2s(formatEncodingException(shortMessage, hint), cause);
        captureStack($this, $this.t2s_1);
        $this.q2s_1 = shortMessage;
        $this.r2s_1 = classSerialName;
        $this.s2s_1 = hint;
        return $this;
      }
    }
    initMetadataForClass($, 'JsonEncodingException');
    JsonEncodingExceptionClass = $;
  }
  return JsonEncodingExceptionClass;
}
//region block: exports
export {
  JsonDecodingException as JsonDecodingExceptionoyag1psadwuw,
  JsonEncodingException as JsonEncodingException3vzv9k0f9l05u,
};
//endregion

//# sourceMappingURL=JsonExceptions.mjs.map
